var emailRegex = /^(?!.*@example\.com$)[\w-+.]+@([\w-]+\.)+[\w-]{2,}$/;
export default emailRegex;